import Products from 'merchandise-lib/constants/Product';
import { MerchCardColumns } from 'pricing-pages-ui-components/components/MerchCardColumns';
import { PageSection } from 'pricing-pages-ui-components/semantic/PageSection';
import { useShouldHideDataOrSuitePage } from '../../../hooks/useShouldHideDataOrSuitePage';
import { BaseCardBadge } from '../../../v2/components/merch-card/BaseCardBadge';
import { SCREENS } from '../../../v2/constants/tracking/Screens';
import { FREE_CARD } from '../../../v2/constants/tracking/TrackingSources';
import { useBadges } from '../../../v2/hooks/badges/useBadges';
import { FreeCard } from '../cards/FreeCard';
import { StandardSuiteCard } from '../cards/suite/StandardSuiteCard';
import FreeProducts from 'merchandise-lib/constants/FreeProduct';

// This is used as the merch cards for the free page routes
import { jsx as _jsx } from "react/jsx-runtime";
export const FreePageCardContainer = () => {
  const shouldHideDataOrSuitePage = useShouldHideDataOrSuitePage();
  const productLevelsToShow = ['FREE', 'STARTER'];
  const productsToShow = [FreeProducts.HUBSPOT_FREE, Products.CRM_SUITE_STARTER_BUNDLE];
  const {
    badges,
    hasBadgeOnFirstColumn,
    hasBadgeOnLastColumn
  } = useBadges({
    productApiNames: productsToShow
  });
  const suiteCardComponents = productLevelsToShow.map((productLevel, index) => {
    var _badges$Products$CRM_;
    if ('FREE' === productLevel) {
      return /*#__PURE__*/_jsx(FreeCard, {
        productLine: "crm",
        columnStart: index + 1,
        trackingSource: FREE_CARD
      }, productLevel);
    }
    if (shouldHideDataOrSuitePage) {
      return null;
    }
    return /*#__PURE__*/_jsx(StandardSuiteCard, {
      productLevel: productLevel,
      screen: SCREENS.FREE,
      columnStart: index + 1,
      Badge: /*#__PURE__*/_jsx(BaseCardBadge, {
        badgeName: badges === null || badges === void 0 || (_badges$Products$CRM_ = badges[Products.CRM_SUITE_STARTER_BUNDLE]) === null || _badges$Products$CRM_ === void 0 ? void 0 : _badges$Products$CRM_.badgeName,
        apiName: Products.CRM_SUITE_STARTER_BUNDLE
      })
    }, productLevel);
  });
  const columns = shouldHideDataOrSuitePage ? productLevelsToShow.length - 1 : productLevelsToShow.length;
  return /*#__PURE__*/_jsx(PageSection, {
    hideOverflow: false,
    children: /*#__PURE__*/_jsx(MerchCardColumns, {
      columns: columns,
      hasBadgeOnFirstColumn: hasBadgeOnFirstColumn,
      hasBadgeOnLastColumn: hasBadgeOnLastColumn,
      children: suiteCardComponents
    })
  });
};